import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getClientConfig } from '../../config/clientConfig';
import HELPERS from '../../utils/helper';
import { Toast, toastMsgConfig } from '../toast';
import apis from '../../config/apis';
import './template8.css';

// Modern Card-Based Template Design
class EnquiryTemplate8 extends Component {
  constructor(props) {
    super(props);
    const clientConfig = getClientConfig(props.clientId);

    if (!clientConfig) {
      this.state = {
        loader: false,
        clientConfig: null,
        formData: {},
        errors: {},
        disabled: true,
        areas: [],
        courses: [],
      };
      return;
    }

    this.state = {
      loader: false,
      formData: {
        name: '',
        phone: '',
        email: '',
        area: '',
        course: '',
        message: ''
      },
      errors: {},
      disabled: false,
      areas: [],
      clientConfig: clientConfig,
      courses: clientConfig.courses,
    };
  }

  componentDidMount() {
    if (this.state.clientConfig) {
      this.fetchAreas();
      this.fetchCourses();
    }
  }

  fetchAreas = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Timezone': 'Asia/Calcutta'
        }
      };
      const areasUrl = apis.getAreasUrl(clientConfig);
      const res = await HELPERS.ApiCall(areasUrl, {}, 'GET', 'proctur', headers);
      if (res.status === 200 && res.data) {
        const result = res.data.result || res.data.data || res.data;
        const areas = [];

        if (Array.isArray(result)) {
          result.forEach(item => {
            if (item.areaList && Array.isArray(item.areaList)) {
              item.areaList.forEach(areaObj => {
                if (areaObj.area) {
                  areas.push(areaObj.area);
                }
              });
            }
          });
        }

        if (areas.length > 0) {
          this.setState({ areas });
        } else {
          this.useFallbackAreas();
        }
      }
    } catch (err) {
      this.useFallbackAreas();
    }
  }

  useFallbackAreas = () => {
    this.setState({
      areas: ['Vesu', 'Adajan', 'Varachha', 'Piplod', 'City Light', 'Athwa', 'Rander', 'Althan']
    });
  }

  fetchCourses = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Timezone': 'Asia/Calcutta'
        }
      };

      const coursesUrl = apis.getCoursesUrl(clientConfig);
      const res = await HELPERS.ApiCall(coursesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const courseList = res.data.data || res.data;
        const courses = [];

        if (Array.isArray(courseList)) {
          courseList.forEach(item => {
            if (item.master_course) {
              courses.push(item.master_course);
            }
          });
        }

        if (courses.length > 0) {
          this.setState({ courses });
        } else {
          this.useFallbackCourses();
        }
      } else {
        this.useFallbackCourses();
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
      this.useFallbackCourses();
    }
  }

  useFallbackCourses = () => {
    const { clientConfig } = this.state;
    if (clientConfig && clientConfig.courses) {
      this.setState({ courses: clientConfig.courses });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }));
  }

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = 'Name is required';
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      errors.phone = 'Please enter a valid 10-digit phone number';
    }

    if (formData.email.trim() && !HELPERS.validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (!formData.course.trim()) {
      errors.course = 'Please select a course';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    this.setState({ loader: true, disabled: true });

    try {
      const { clientConfig, formData } = this.state;
      const headers = {
        headers: {
          'Authorization': clientConfig.api.authorization,
          'Content-Type': 'application/json',
          'source': 'WEB',
          'accept': 'application/json, text/plain, */*'
        }
      };

      const payload = {
        name: formData.name,
        mobile: formData.phone,
        email: formData.email || '',
        comments: formData.message || 'No additional message',
        institute_id: clientConfig.instituteId,
        customComponentList: [],
        mCourseName: formData.course || '',
        state: clientConfig.api.defaults.state,
        city: clientConfig.api.defaults.city,
        area: formData.area || clientConfig.api.defaults.defaultArea
      };

      const apiUrl = apis.getApiUrl(clientConfig);
      const res = await HELPERS.ApiCall(apiUrl, payload, 'POST', 'proctur', headers);

      if (res.status === 200 || res.status === 201) {
        Toast('Thank you! Your enquiry has been submitted successfully.', toastMsgConfig('s'));
        this.setState({
          formData: {
            name: '',
            phone: '',
            email: '',
            area: '',
            course: '',
            message: ''
          },
          loader: false,
          disabled: false
        });
      } else {
        Toast('Something went wrong. Please try again.', toastMsgConfig('e'));
        this.setState({ loader: false, disabled: false });
      }
    } catch (error) {
      Toast('Failed to submit enquiry. Please try again.', toastMsgConfig('e'));
      this.setState({ loader: false, disabled: false });
    }
  }

  render() {
    const { formData, errors, disabled, loader, areas, courses, clientConfig } = this.state;

    if (!clientConfig) {
      return null;
    }

    return (
      <div className="template8-container">
        {/* Hero Section with Split Layout */}
        <div className="template8-hero">
          <div className="template8-hero-left">
            <div className="template8-brand">
              <img src={clientConfig.branding.logo} alt={clientConfig.clientName + " Logo"} className="template8-logo" />
              <h1 className="template8-title">{clientConfig.branding.heroTitle}</h1>
            </div>
            <p className="template8-subtitle">{clientConfig.branding.heroSubtitle}</p>

            {/* Stats Grid */}
            <div className="template8-stats-grid">
              <div className="template8-stat-card">
                <div className="template8-stat-icon">
                  <i className="fa fa-users"></i>
                </div>
                <div className="template8-stat-content">
                  <h3>{clientConfig.stats.alumni}</h3>
                  <p>Alumni</p>
                </div>
              </div>
              <div className="template8-stat-card">
                <div className="template8-stat-icon">
                  <i className="fa fa-clock"></i>
                </div>
                <div className="template8-stat-content">
                  <h3>{clientConfig.stats.experience} Years</h3>
                  <p>Experience</p>
                </div>
              </div>
              <div className="template8-stat-card">
                <div className="template8-stat-icon">
                  <i className="fa fa-briefcase"></i>
                </div>
                <div className="template8-stat-content">
                  <h3>{clientConfig.stats.placement}</h3>
                  <p>Placement</p>
                </div>
              </div>
              <div className="template8-stat-card">
                <div className="template8-stat-icon">
                  <i className="fa fa-handshake"></i>
                </div>
                <div className="template8-stat-content">
                  <h3>{clientConfig.stats.partners}</h3>
                  <p>Partners</p>
                </div>
              </div>
            </div>

            {/* Features */}
            <div className="template8-features">
              <h3>Why Choose Us?</h3>
              <div className="template8-features-list">
                {clientConfig.features.map((feature, index) => (
                  <div key={index} className="template8-feature-item">
                    <i className="fa fa-check-circle"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Side - Form Card */}
          <div className="template8-hero-right">
            <div className="template8-form-card">
              <div className="template8-form-header">
                <h2>Start Your Journey</h2>
                <p>Fill in your details and we'll get back to you</p>
              </div>

              <form onSubmit={this.handleSubmit} className="template8-form">
                <div className="template8-form-group">
                  <label>
                    <i className="fa fa-user"></i>
                    Full Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={this.handleChange}
                    placeholder="Enter your full name"
                    className={errors.name ? 'error' : ''}
                  />
                  {errors.name && <span className="template8-error">{errors.name}</span>}
                </div>

                <div className="template8-form-group">
                  <label>
                    <i className="fa fa-phone"></i>
                    Phone Number <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={this.handleChange}
                    placeholder="Enter your 10-digit phone number"
                    maxLength="10"
                    className={errors.phone ? 'error' : ''}
                  />
                  {errors.phone && <span className="template8-error">{errors.phone}</span>}
                </div>

                <div className="template8-form-group">
                  <label>
                    <i className="fa fa-envelope"></i>
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={this.handleChange}
                    placeholder="Enter your email (optional)"
                    className={errors.email ? 'error' : ''}
                  />
                  {errors.email && <span className="template8-error">{errors.email}</span>}
                </div>

                <div className="template8-form-group">
                  <label>
                    <i className="fa fa-map-marker"></i>
                    Area
                  </label>
                  <select
                    name="area"
                    value={formData.area}
                    onChange={this.handleChange}
                  >
                    <option value="">Select your area</option>
                    {areas.map((area, index) => (
                      <option key={index} value={area}>{area}</option>
                    ))}
                  </select>
                </div>

                <div className="template8-form-group">
                  <label>
                    <i className="fa fa-graduation-cap"></i>
                    Course <span className="required">*</span>
                  </label>
                  <select
                    name="course"
                    value={formData.course}
                    onChange={this.handleChange}
                    className={errors.course ? 'error' : ''}
                  >
                    <option value="">Select a course</option>
                    {courses.map((course, index) => (
                      <option key={index} value={course}>{course}</option>
                    ))}
                  </select>
                  {errors.course && <span className="template8-error">{errors.course}</span>}
                </div>

                <div className="template8-form-group">
                  <label>
                    <i className="fa fa-comment"></i>
                    Message
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={this.handleChange}
                    placeholder="Tell us about your interests or questions..."
                    rows="3"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="template8-submit-btn"
                  disabled={disabled || loader}
                >
                  {loader ? (
                    <>
                      <i className="fa fa-spinner fa-spin"></i> Submitting...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-paper-plane"></i> Submit Enquiry
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Contact Footer */}
        <div className="template8-footer">
          <div className="template8-contact-info">
            <div className="template8-contact-item">
              <i className="fa fa-phone-square"></i>
              <div>
                <p className="label">Call Us</p>
                <p className="value">{clientConfig.contactInfo.phone1} / {clientConfig.contactInfo.phone2}</p>
              </div>
            </div>
            <div className="template8-contact-item">
              <i className="fa fa-envelope-square"></i>
              <div>
                <p className="label">Email</p>
                <p className="value">{clientConfig.contactInfo.email}</p>
              </div>
            </div>
            <div className="template8-contact-item">
              <i className="fa fa-globe"></i>
              <div>
                <p className="label">Website</p>
                <p className="value">{clientConfig.contactInfo.website}</p>
              </div>
            </div>
            <div className="template8-contact-item">
              <i className="fa fa-map-marker-alt"></i>
              <div>
                <p className="label">Address</p>
                <p className="value">{clientConfig.contactInfo.address}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

const ConnectedEnquiryTemplate8 = connect(mapStateToProps)(EnquiryTemplate8);
export default ConnectedEnquiryTemplate8;
